import { Spin } from 'antd';
import './HookLoader.scss';

interface Props {
    loading: boolean
}

function HookLoader({ loading }: Props) {

    if (!loading) return null;
    return (
        <div className="loader-container">
            <Spin className="spinner-loader" size="large" />
        </div>
    )
}

export default HookLoader;